import React, { useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import moment from 'moment';

export default function DialogValorizzazione({ open, onClose, onConfirm }) {
    const [dataValorizzazione, setDataValorizzazione] = useState(moment().format('YYYY-MM-DD'));
    const [tipoValorizzazione, setTipoValorizzazione] = useState('magazzino'); // 'magazzino' o 'cespiti'

    const handleConfirm = () => {
        if (moment(dataValorizzazione).isValid()) {
            onConfirm(dataValorizzazione, tipoValorizzazione);
            onClose();
        } else {
            alert('Data non valida. Inserire una data nel formato YYYY-MM-DD.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Valorizzazione</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="data"
                    label="Data di valorizzazione"
                    type="date"
                    fullWidth
                    variant="standard"
                    value={dataValorizzazione}
                    onChange={(e) => setDataValorizzazione(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <RadioGroup
                    row
                    aria-label="tipo-valorizzazione"
                    name="row-radio-buttons-group"
                    value={tipoValorizzazione}
                    onChange={(e) => setTipoValorizzazione(e.target.value)}
                >
                    <FormControlLabel value="magazzino" control={<Radio />} label="Magazzino" />
                    <FormControlLabel value="cespiti" control={<Radio />} label="Cespiti" />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annulla</Button>
                <Button onClick={handleConfirm}>Conferma</Button>
            </DialogActions>
        </Dialog>
    );
}